import React from "react";
import Timer from "./Timer.mjs";

export default function DateBlock({ startDateTime }) {
  const now = new Date().getTime();
  const distance = startDateTime.getTime() - now;
  const inProgress = distance < 0;

  const dateString = startDateTime.toLocaleDateString([], {
    month: "short",
    day: "numeric",
  });

  return (
    <div className="w-100 bg-primary text-white text-center p-2 rounded">
      <span className="d-block h1 text-white mb-1">{dateString}</span>
      {!inProgress && (
        <span className="d-block label-2 text-white pb-2">Starts in:</span>
      )}
      <div className="px-3 py-2 bg-red-dark">
        <Timer startTime={startDateTime} />
      </div>
    </div>
  );
}
